import { useLocalStorage } from "../../../hooks/useLocalStorage";
import { useCmmsNotifications } from "../../../hooks/useCmmsNotifications";
import { useIsCmmsEnabled } from "../cmmsFeature";

/*
 * Mounts the CMMS SignalR connection for the whole authenticated app.
 *
 * Renders nothing — it exists so App.js can start the connection from inside
 * AuthProvider and QueryClientProvider (both of which the hook needs) without
 * App.js having to know about CMMS.
 *
 * App-wide on purpose: a technician should be told about a new work order wherever
 * they are, not only while the work order list happens to be open. The hook itself
 * skips the connection for users without a CMMS role.
 *
 * The module switch is passed into the hook rather than used to skip rendering: hooks
 * cannot be called conditionally, and the requirement is that no socket is opened when
 * CMMS is off — not merely that nothing is displayed.
 */
export default function CmmsNotifications() {
  const [companyKey] = useLocalStorage("companyKey", 1);
  const cmmsEnabled = useIsCmmsEnabled();
  useCmmsNotifications(companyKey, cmmsEnabled);
  return null;
}
